import React from 'react'

const ShipmentMgt = () => {
  return (
    <div>ShipmentMgt</div>
  )
}

export default ShipmentMgt